import { Column, Grid, Icon, ProgressStepper, StyledLabel } from 'components';
import CartSideBar from 'components/CartSideBar';
import { redirectToPage } from 'helpers/navigation';
import React, { ReactNode } from 'react';
import { isEqual } from 'helpers/conditionals';
import 'react-toastify/dist/ReactToastify.min.css';
import { useSelector } from 'react-redux';
import { isVirtualCartSelector } from 'store/cart/selectors';
import OverlayComponents from './OverlayComponents';
import { Link } from 'gatsby';
import { Show } from 'components/Functional';
import LogoSvg from '../../icons/Logo.svg';
import { TrackingProp } from 'react-tracking';
import SvgContainer from 'icons/SvgContainer';
import { SPLIT_IO_FEATURE_FLAG_ZEN_DESK, SPLIT_IO_FEATURE_FLAG_ZEN_DESK_COOKIE, ZenDesk } from 'components/Zendesk';
import { useSplitTreatment } from 'hooks/splits/useSplitTreatment';
import { PromoBannerESIBlock } from 'components/PromoBannerESIBlock';
import { BackToCartButton, Container, Header, LogoContainer, LogoWrapper, StepperWrapper } from './styled/checkout';

interface CheckoutLayoutProps {
  children: ReactNode;
  activeStep: string;
  ctaButton: ReactNode;
  tracking: TrackingProp;
  cartId: number;
  isFinalStep?: boolean;
}

const CheckoutLayout = ({
  children,
  activeStep,
  ctaButton,
  isFinalStep,
  tracking,
  cartId
}: CheckoutLayoutProps): React.JSX.Element => {
  const { treatmentStatus: zenDeskOn } = useSplitTreatment(
    SPLIT_IO_FEATURE_FLAG_ZEN_DESK,
    SPLIT_IO_FEATURE_FLAG_ZEN_DESK_COOKIE
  );
  const isBillingPage = isEqual(activeStep)('billing');
  const isVirtualCart = useSelector(isVirtualCartSelector);

  return (
    <>
      {/* We need to load to Promo Banner ESI block to maintain Reacts internal routing 
        but we do not want to display it on the checkout pages */}
      <div style={{ display: 'none' }}>
        <PromoBannerESIBlock />
      </div>
      <Container>
        <Header>
          <LogoWrapper>
            <Link to="/">
              <LogoContainer>{SvgContainer(LogoSvg)}</LogoContainer>
            </Link>
          </LogoWrapper>
          <BackToCartButton
            onClick={() => {
              if (isBillingPage) {
                redirectToPage('/checkout/shipping');
              } else {
                redirectToPage('/checkout/cart');
              }
            }}
            role="button"
          >
            <Icon icon="back" color="#000" />
            <StyledLabel>Back To {isBillingPage ? 'Shipping' : 'Cart'}</StyledLabel>
          </BackToCartButton>
          <StepperWrapper>
            <ProgressStepper steps={['shipping', 'billing', 'review']} activeStep={activeStep} />
          </StepperWrapper>
        </Header>
        <Grid gutter={isVirtualCart ? 50 : 25}>
          <Column size={12} medium={6}>
            {children}
          </Column>
          <Show when={!isVirtualCart}>
            <Column size={12} medium={2} />
          </Show>
          <Column size={12} medium={4}>
            <CartSideBar isFinalStep={isFinalStep} ctaButton={ctaButton} tracking={tracking} cartId={cartId} />
          </Column>
        </Grid>
      </Container>
      <OverlayComponents />
      {zenDeskOn && <ZenDesk />}
    </>
  );
};

export default CheckoutLayout;
